import React, { useContext } from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import TableFooter from "../../components/TableFooter";
import SearchTopBar from "../../components/SearchTopBar";
import { decryptText } from "../../utils/cipherText";
import ImageLoading from "../../components/ImageLoading";
import NoDataFound from "../../components/NoDataFound";
import NoSearchitems from "../../components/NoSearchitems";
import all from "../../images/all.png";
import desc from "../../images/desc.png";
import asc from "../../images/asc.png";
import { CgArrowUp, CgArrowDown } from "react-icons/cg";
import { TbFilterX } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { sideBarContext } from "../../App";
// redux imports
import { useDispatch, useSelector } from "react-redux";
import {
  updateSortNameRepayment,
  updateSortOrderRepayment,
} from "../../redux/slices/sortSlice";

const SortTableHeader = ({
  title,
  handleSort,
  sortBy,
  sortType,
  param,
  setSortBy,
  setSortType,
  setOpenSorting,
  openSorting,
}) => {
  return (
    <button
      className=" flex items-center relative"
      onClick={() => {
        if (sortType !== param) {
          setSortBy("");
          setSortType(param);
        }

        if (!openSorting || sortType !== param) {
          setOpenSorting(true);
        } else if (openSorting && sortType === param) {
          setOpenSorting(false);
        }
      }}
    >
      {" "}
      {openSorting && sortType === param && (
        <div
          className={`w-[162px] px-2 rounded-lg absolute z-[11] bg-white top-6 text-xs font-medium shadow-md py-2 right-[2px]`}
        >
          <div
            className={`flex flex-row justify-start items-center gap-3 font-medium text-xs text-[#262626] pl-2 py-1 rounded hover:bg-[#E6EBED] cursor-pointer ${
              sortBy === "asc" && "bg-[#A0FF77]"
            }`}
            onClick={() => {
              setSortBy("asc");
              setOpenSorting(false);
            }}
          >
            <CgArrowUp size={"15px"} /> Sort Ascending
          </div>
          <div
            className={`flex flex-row justify-start items-center gap-3 font-medium text-xs text-[#262626] mt-2 pl-2 py-1 rounded hover:bg-[#E6EBED] cursor-pointer ${
              sortBy === "desc" && "bg-[#A0FF77]"
            }`}
            onClick={() => {
              setSortBy("desc");
              setOpenSorting(false);
            }}
          >
            <CgArrowDown size={"15px"} /> Sort Descending
          </div>
          {sortBy && (
            <div className="flex flex-row justify-center items-center w-full">
              <button
                type="button"
                className="py-[3px] px-2 rounded w-[73px] h-6 font-medium  text-[#00394d] border border-[#00394d] mt-3 flex flex-row justify-center items-center gap-2"
                onClick={() => {
                  setSortBy("");
                  setSortType("");
                  setSortType("");
                  setOpenSorting(false);
                }}
              >
                <TbFilterX size={"15px"} /> Clear
              </button>
            </div>
          )}
        </div>
      )}
      <p className="flex items-center text-left">{title}</p>
      <span
        className={`ml-1 ${
          sortType === param && sortBy !== ""
            ? "visible !opacity-100"
            : "visible"
        }`}
      >
        {sortType === param && sortBy === "asc" ? (
          <img src={asc} alt="sort" className="" />
        ) : sortType === param && sortBy === "desc" ? (
          <img src={desc} alt="sort" className="" />
        ) : (
          <img src={all} alt="sort" className="" />
        )}
      </span>
    </button>
  );
};

function Transactions() {
  const navigate = useNavigate();
  const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const [list, setList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [id, setId] = useState("");

  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(rowsPerPage);
  const [pageNo, setPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [totalRows, setTotalRows] = useState();
  const [searchPages, setSearchPages] = useState();
  const [searchRows, setSearchRows] = useState();
  const [filterShow, setFilterShow] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("name");
  // const [searchQuery, setSearchQuery] = useState("");

  const [transactionShow, setTransactionShow] = useState([]);
  const [transactionShowText, setTransactionShowText] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState("executed");
  const [imageLoading, setImageLoading] = useState(false);
  const [searchEmpty, setSearchEmpty] = useState(false);
  const storedSearch = sessionStorage.getItem("query") || "";
  const [searchQuery, setSearchQuery] = React.useState(storedSearch);
  const [optionSelected, setOptionSelected] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [triggerFilter, setTriggerFilter] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [emiValue, setEmiValue] = useState("");
  const sortNameRedux = useSelector((state) => state.sort.repaymentSortName);
  const sortOrderRedux = useSelector((state) => state.sort.repaymentSortOrder);
  const dispatch = useDispatch();
  const sortStates = ["", "asc", "desc"];
  const [sortType, setSortType] = useState(sortNameRedux || "");
  const [sortBy, setSortBy] = useState(sortOrderRedux || sortStates[0]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [openSorting, setOpenSorting] = useState(false);
  const [message, setMessage] = useState("");
  const [switchOd, setSwitchOd] = useState(false);
  const [type, setType] = useState("all");
  const { expanded } = useContext(sideBarContext);

  const sortFunction = (param) => {
    if (sortType !== param) {
      setSortBy("");
      setSortType(param);
    }

    if (!openSorting || sortType !== param) {
      setOpenSorting(true);
    } else if (openSorting && sortType === param) {
      setOpenSorting(false);
    }
  };

  const fetchOrders = async () => {
    setImageLoading(true);

    // const token = localStorage.getItem("token");
    const token = localStorage.getItem("token");
    let url = `${
      process.env.REACT_APP_URL
    }/lender/orders?page=${pageNo}&rows_per_page=${rowsPerPage}&transaction_status=${emiValue}&disbursement_status=${statusFilter}&start_date=${formatDate(
      startDate
    )}&end_date=${formatDate(endDate)}&sort_by=${
      sortType !== "" ? sortType + sortBy : ""
    }`;
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(url, options);
      setTotalRows(res.data.total_entries);
      setTotalPages(res.data.total_pages);
      setList(res.data.order_details);
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };
  const fetchSearchedOrders = async () => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    let url = `${
      process.env.REACT_APP_URL
    }/lender/orders/search?search_field=${selectedFilter}&search_term=${searchQuery}&page=${pageNo}&transaction_status=${emiValue}&disbursement_status=${statusFilter}&start_date=${formatDate(
      startDate
    )}&end_date=${formatDate(endDate)}&sort_by=${
      sortType !== "" ? sortType + sortBy : ""
    }`;

    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(url, options);
      setSearchPages(res.data.total_pages);
      setSearchRows(res.data.total_entries);
      if (res.data.order_details.length < 1) {
        setSearchEmpty(true);
      }
      if (res.data.order_details.length > 0) {
        setSearchList(res.data.order_details);
        setSearchEmpty(false);
      }
      setImageLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const formatDate = (date) => {
    if (date === null) return "";
    const dateFormat = new Date(date);
    const day = String(dateFormat.getDate()).padStart(2, "0");
    const month = String(dateFormat.getMonth() + 1).padStart(2, "0"); // Months are 0-based in JavaScript
    const year = dateFormat.getFullYear();
    let ans = `${year}-${month}-${day}`;
    return ans;
  };

  useEffect(() => {
    if (searchQuery !== "") {
      fetchSearchedOrders();
      setList([]);
      setTotalPages();
      setTotalRows();
    }
    if (searchQuery === "") {
      fetchOrders();
      setSearchList([]);
      setSearchPages();
      setSearchRows();
      setSearchEmpty(false);
    }
  }, [searchQuery, triggerFilter, sortBy]);

  useEffect(() => {
    if (searchQuery) {
      fetchSearchedOrders();
      return;
    }
    fetchOrders();
  }, [pageNo, rowsPerPage]);

  const displayedRows = list.length > 0 ? list : searchList;
  const noOfRows = list.length > 0 ? totalRows : searchRows;
  const noOfPages = list.length > 0 ? totalPages : searchPages;

  const handleClick = async () => {
    setTransactionShow([]);
    if (id !== "") {
      setImageLoading(true);
      const token = localStorage.getItem("token");
      let options;
      if (switchOd) {
        options = {
          headers: {
            Authorization: token,
          },
          url: `${process.env.REACT_APP_URL}/lender/orders/${id}`,
          method: "GET",
        };
      } else {
        options = {
          headers: {
            Authorization: token,
          },
          url: `${process.env.REACT_APP_URL}/lender/orders/${id}?transaction=${selectedPayment}`,
          method: "GET",
        };
      }
      try {
        const response = await axios(options);
        setTransactionShow(response.data);
        setImageLoading(false);
      } catch (error) {
        setTransactionShow([]);
        setImageLoading(false);
      }
    }
  };

  useEffect(() => {
    handleClick();
  }, [id, selectedPayment, switchOd]);

  const filterList = ["name"];

  const alterStatus = (inputString) => {
    if (inputString === "INITIATED") {
      return "pending";
    } else {
      return inputString?.replace(/_/g, " ").toLowerCase();
    }
  };
  const handleSort = (type) => {
    let byValue = sortStates[(sortStates.indexOf(sortBy) + 1) % 3];

    if (sortType === type && byValue === "") {
      setSortType("");
      setSortBy(byValue);
      return;
    }
    if (sortType !== type) {
      byValue = "asc";
      setSortBy(byValue);
      setSortType(type);
      return;
    }

    setSortBy(byValue);
  };

  //save sort data to redux
  useEffect(() => {
    dispatch(updateSortNameRepayment(sortType));
    dispatch(updateSortOrderRepayment(sortBy));
  }, [sortType, sortBy]);
  return (
    <div
      className={`${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      } bg-[#f1f1f6] h-[100vh] px-[20px] pt-[16px]`}
    >
      <div className="mt-4 rounded-lg bg-white mb-4 p-4">
        <p className="text-[#262626] text-xl font-semibold">Repayment</p>
      </div>
      {!transactionShowText ? (
        <>
          <div className=" bg-white px-4 flex flex-col justify-between pt-2 rounded-t-lg">
            <SearchTopBar
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              filterList={filterList}
              filterShow={filterShow}
              setFilterShow={setFilterShow}
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
              downloadPageWord="transactions"
              optionSelected={optionSelected}
              setOptionSelected={setOptionSelected}
              statusFilter={statusFilter}
              setStatusFilter={setStatusFilter}
              triggerFilter={triggerFilter}
              setTriggerFilter={setTriggerFilter}
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setEmiValue={setEmiValue}
              emiValue={emiValue}
              filterApplied={filterApplied}
              setFilterApplied={setFilterApplied}
            />
          </div>
          <div className="pt-2 w-full bg-white">
            {imageLoading && (
              <div className="w-full h-[calc(100vh-245px)] flex items-center justify-center">
                <ImageLoading />
              </div>
            )}
            {!imageLoading && (
              <>
                {/* <div className="flex items-center text-sm gap-8 px-4">
                  <p
                    className={`${
                      type === "all"
                        ? "border-b-[3px] border-b-solid border-b-[#00394D] font-bold"
                        : "font-medium"
                    } py-2 cursor-pointer text-[#262626] text-sm`}
                    onClick={() => {
                      setType("all");
                    }}
                  >
                    All
                  </p>
                  <p
                    className={`${
                      type === "term"
                        ? "border-b-[3px] border-b-solid border-b-[#00394D] font-bold"
                        : "font-medium"
                    } py-2 cursor-pointer text-[#262626] text-sm`}
                    onClick={() => {
                      setType("term");
                    }}
                  >
                    Term Loan
                  </p>
                  <p
                    className={`${
                      type === "od"
                        ? "border-b-[3px] border-b-solid border-b-[#00394D] font-bold"
                        : "font-medium"
                    } py-2 cursor-pointer text-[#262626] text-sm`}
                    onClick={() => {
                      setType("od");
                    }}
                  >
                    Overdraft Loan
                  </p>
                </div> */}
                <table className="w-full box-border h-full flex flex-col pt-3">
                  <thead className="text-sm font-semibold h-full">
                    <tr className="w-full flex items-center">
                      <th className="text-center pl-2 pr-4 pt-3 pb-2 w-[5%] text-sm font-semibold">
                        #
                      </th>
                      <th className={`text-left w-[11%] text-sm font-semibold`}>
                        <SortTableHeader
                          title={"Username"}
                          sortBy={sortBy}
                          sortType={sortType}
                          handleSort={handleSort}
                          param={"user_name_"}
                          openSorting={openSorting}
                          setOpenSorting={setOpenSorting}
                          setSortType={setSortType}
                          setSortBy={setSortBy}
                        />
                      </th>
                      <th className={`text-left w-[15%] text-sm font-semibold`}>
                        <SortTableHeader
                          title={"Monthly EMI Amount"}
                          sortBy={sortBy}
                          sortType={sortType}
                          handleSort={handleSort}
                          param={"monthly_emi_amount_"}
                          openSorting={openSorting}
                          setOpenSorting={setOpenSorting}
                          setSortType={setSortType}
                          setSortBy={setSortBy}
                        />
                      </th>
                      <th className={`text-left w-[8%] text-sm font-semibold`}>
                        <SortTableHeader
                          title={"Tenure"}
                          sortBy={sortBy}
                          sortType={sortType}
                          handleSort={handleSort}
                          param={"tenure_"}
                          openSorting={openSorting}
                          setOpenSorting={setOpenSorting}
                          setSortType={setSortType}
                          setSortBy={setSortBy}
                        />
                      </th>
                      <th className="text-left w-[12%] text-sm font-semibold">
                        <SortTableHeader
                          title={"EMI Start Date"}
                          sortBy={sortBy}
                          sortType={sortType}
                          handleSort={handleSort}
                          param={"emi_start_date_"}
                          openSorting={openSorting}
                          setOpenSorting={setOpenSorting}
                          setSortType={setSortType}
                          setSortBy={setSortBy}
                        />
                      </th>
                      <th
                        className={`text-left w-[10%] text-sm font-semibold inline-flex items-center cursor-pointer`}
                      >
                        <SortTableHeader
                          title={"Loan Value"}
                          sortBy={sortBy}
                          sortType={sortType}
                          handleSort={handleSort}
                          param={"loan_value_"}
                          openSorting={openSorting}
                          setOpenSorting={setOpenSorting}
                          setSortType={setSortType}
                          setSortBy={setSortBy}
                        />
                      </th>
                      <th className={`text-left w-[13%] text-sm font-semibold`}>
                        <SortTableHeader
                          title={"Repayment Value"}
                          sortBy={sortBy}
                          sortType={sortType}
                          handleSort={handleSort}
                          param={"total_repayment_value_"}
                          openSorting={openSorting}
                          setOpenSorting={setOpenSorting}
                          setSortType={setSortType}
                          setSortBy={setSortBy}
                        />
                      </th>
                      <th className={`text-left w-[13%] text-sm font-semibold`}>
                        <SortTableHeader
                          title={"Lastest Transaction"}
                          sortBy={sortBy}
                          sortType={sortType}
                          handleSort={handleSort}
                          param={"latest_user_transactions_"}
                          openSorting={openSorting}
                          setOpenSorting={setOpenSorting}
                          setSortType={setSortType}
                          setSortBy={setSortBy}
                        />
                      </th>
                      <th
                        className={`text-left w-[13%] text-sm font-semibold inline-flex justify-start items-center`}
                      >
                        Transaction Status
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    className={`overflow-auto max-h-[calc(100vh-270px)] ${
                      displayedRows.length === 0 ||
                      (searchEmpty && searchQuery !== "")
                        ? "h-[calc(100vh-245px)]"
                        : ""
                    }`}
                  >
                    {searchEmpty && searchQuery !== "" ? (
                      <>
                        <NoSearchitems />
                      </>
                    ) : (
                      <>
                        {displayedRows.length > 0 ? (
                          <>
                            {displayedRows.map((i, index) => (
                              <tr
                                key={index}
                                className={`${
                                  index % 2 === 0 ? "bg-[#f8f8f8]" : ""
                                }  text-xs font-medium w-full flex items-center hover:bg-[#E6EBED] ${
                                  userType === "distributors"
                                    ? ""
                                    : "cursor-pointer"
                                }`}
                                onClick={() => {
                                  if (userType !== "distributors") {
                                    setSwitchOd(false);
                                    setSelectedPayment("executed");
                                    setId(i.id);
                                    setTransactionShowText(true);
                                    setMessage(i);
                                  }
                                }}
                              >
                                <td className="text-center pl-2 pr-4 pt-3 pb-2 w-[5%] text-xs font-medium">
                                  {startIndex + index + 1}
                                </td>
                                <td
                                  className={`text-left w-[11%] text-xs font-medium`}
                                  onClick={() => {
                                    if (userType !== "distributors") {
                                      setId(i.id);
                                      setTransactionShowText(true);
                                    }
                                  }}
                                >
                                  {i.name
                                    ? i.name?.toLowerCase().slice(0, 16) +
                                      (i.name.length > 16 ? "..." : "")
                                    : "--"}
                                </td>
                                <td
                                  className={`text-left w-[15%] text-xs font-medium`}
                                >
                                  {i.monthly_emi_amount || "--"}
                                </td>
                                <td
                                  className={`text-left w-[8%] text-xs font-medium`}
                                >
                                  {i.tenure || "--"}
                                </td>
                                <td className="text-left w-[12%] text-xs font-medium">
                                  {i.emi_start_date || "--"}
                                </td>
                                <td
                                  className={`text-left w-[10%] text-xs font-medium`}
                                >
                                  {i.loan_value?.toFixed(2) || "--"}
                                </td>
                                <td
                                  className={`text-left w-[13%] text-xs font-medium`}
                                >
                                  {i?.total_repayment_value?.toFixed(2) || "--"}
                                </td>
                                <td
                                  className={`text-left w-[13%] text-xs font-medium`}
                                >
                                  {i.last_transaction || "--"}
                                </td>
                                <td className={`text-left w-[13%]`}>
                                  <span
                                    className={` ${
                                      i.transaction_status === "Disbursed"
                                        ? "bg-[#F0FDF4] text-[#188240] border-[#C4EBD2] border-[0.5px]"
                                        : "bg-[#FDF0F0] text-[#C33D3D] border-[#EBC4C4] border-[0.5px] capitalize"
                                    } rounded-full cursor-default px-2 py-1 text-xs font-medium`}
                                  >
                                    {i.transaction_status || "--"}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <>
                            <NoDataFound insidePage={false} />
                          </>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </>
            )}
          </div>
          <TableFooter
            totalPages={noOfPages}
            totalRows={noOfRows}
            rowsPerPage={rowsPerPage}
            startIndex={startIndex}
            setStartIndex={setStartIndex}
            setEndIndex={setEndIndex}
            endIndex={endIndex}
            setPageNo={setPageNo}
            pageNo={pageNo}
            setRowsPerPage={setRowsPerPage}
          />
        </>
      ) : (
        <>
          <div className="mt-4 rounded-lg bg-white mb-4 p-4">
            <p className=" text-sm">
              <span
                className="cursor-pointer hover:underline transition ease-in-out duration-500 hover:font-medium"
                onClick={() => setTransactionShowText(false)}
              >
                {" "}
                List of Users{" "}
              </span>
              <span className=" font-bold text-base text-[#262626]">
                {" "}
                &gt; {message?.name || "---"}{" "}
              </span>
            </p>
          </div>
          <div className="pt-3 w-full bg-white pl-[20px]">
            <div className="rounded-[23px] bg-[#F0F0F0] text-sm font-semibold text-[#000000] p-1 inline-block">
              <button
                className={`${
                  !switchOd ? "bg-[#92e86c]" : ""
                } w-[180px] py-[7px] rounded-[19px]`}
                onClick={() => setSwitchOd(false)}
              >
                Term Loan
              </button>
              {message?.od_order && (
                <button
                  className={`${
                    switchOd ? "bg-[#92e86c]" : ""
                  } w-[180px] py-[7px] rounded-[19px]`}
                  onClick={() => setSwitchOd(true)}
                >
                  Overdraft Loan
                </button>
              )}
            </div>
            {switchOd ? (
              <table
                className={`box-border h-full flex flex-col mt-6 ${
                  transactionShow?.transaction_details?.length ? "w-full" : ""
                }`}
              >
                <thead className="text-sm font-semibold h-full w-full">
                  <tr className="w-full flex items-center justify-between">
                    <th className={`text-left text-sm font-semibold w-[20%]`}>
                      Date
                    </th>
                    <th className={`text-left text-sm font-semibold w-[20%]`}>
                      Transaction ID
                    </th>
                    <th className={`text-left text-sm font-semibold w-[20%]`}>
                      Amount paid (&#8377;)
                    </th>
                    <th className={`text-left text-sm font-semibold w-[20%]`}>
                      Transaction Type
                    </th>
                    <th className={`text-left text-sm font-semibold w-[20%]`}>
                      Transaction Status
                    </th>
                  </tr>
                </thead>
                {transactionShow?.transaction_details?.length ? (
                  <tbody
                    className={`overflow-auto max-h-[calc(100vh-340px)] ${
                      transactionShow?.transaction_details?.length === 0
                        ? "h-[calc(100vh-330px)]"
                        : ""
                    }`}
                  >
                    {transactionShow?.transaction_details?.length > 0 &&
                      transactionShow?.transaction_details?.map(
                        (transaction, index) => (
                          <tr
                            key={index}
                            className={`w-full flex items-center py-4 justify-between`}
                          >
                            <td
                              className={`text-left text-xs font-medium w-[20%]`}
                            >
                              {transaction.date || "---"}
                            </td>
                            <td
                              className={`text-left text-xs font-medium w-[20%]`}
                            >
                              {transaction.transactionId || "---"}
                            </td>
                            <td
                              className={`text-left text-xs font-medium w-[20%]`}
                            >
                              &#8377;{transaction.amount_paid}
                            </td>
                            <td
                              className={`text-left text-xs font-medium w-[20%]`}
                            >
                              <span
                                className={`
                                ${
                                  transaction?.transaction_type?.toLowerCase() ===
                                  "interest"
                                    ? "border border-solid border-[#00ACD2] text-[#00ACD2]"
                                    : transaction?.transaction_type?.toLowerCase() ===
                                      "principal"
                                    ? "border border-solid border-[#8826AB] text-[#8826AB]"
                                    : "border border-solid border-[#BDAB00] text-[#BDAB00]"
                                } px-2 py-1 rounded-full cursor-default capitalize flex items-center justify-center w-fit
                              `}
                              >
                                {transaction.transaction_type}
                              </span>
                            </td>
                            <td
                              className={`text-left text-xs font-medium w-[20%]`}
                            >
                              <span
                                className={`
                                ${
                                  transaction?.transaction_status?.toLowerCase() ===
                                  "failed"
                                    ? "red-status"
                                    : transaction?.transaction_status?.toLowerCase() ===
                                      "initiated"
                                    ? "blue-status"
                                    : transaction?.transaction_status?.toLowerCase() ===
                                      "success"
                                    ? "green-status"
                                    : "blue-status"
                                } px-2 py-1 rounded-full cursor-default capitalize flex items-center justify-center w-fit
                              `}
                              >
                                {alterStatus(transaction.transaction_status)}
                              </span>
                            </td>
                          </tr>
                        )
                      )}
                  </tbody>
                ) : (
                  <NoDataFound insidePage={true} />
                )}
              </table>
            ) : (
              <>
                <div className="flex my-4 items-center text-sm gap-8">
                  <p
                    className={`${
                      selectedPayment === "scheduled"
                        ? "border-b-[3px] border-b-solid border-b-[#00394D] font-bold"
                        : "font-medium"
                    } py-2 cursor-pointer text-[#262626] text-sm`}
                    onClick={() => {
                      setSelectedPayment("scheduled");
                    }}
                  >
                    Scheduled payments
                  </p>
                  <p
                    className={`${
                      selectedPayment === "executed"
                        ? "border-b-[3px] border-b-solid border-b-[#00394D] font-bold"
                        : "font-medium"
                    } py-2 cursor-pointer text-[#262626] text-sm`}
                    onClick={() => {
                      setSelectedPayment("executed");
                    }}
                  >
                    Executed payments
                  </p>
                </div>
                <table
                  className={`box-border h-full flex flex-col ${
                    transactionShow?.transaction_details?.length ||
                    transactionShow?.prepayment_transaction?.length
                      ? "w-full"
                      : ""
                  }`}
                >
                  <thead className="text-sm font-semibold h-full w-full">
                    <tr className="w-full flex items-center justify-between">
                      <th
                        className={`text-left text-sm font-semibold ${
                          selectedPayment === "executed" ? "w-[15%]" : "w-[20%]"
                        }`}
                      >
                        Date
                      </th>
                      {/*<th
                        className={`text-left text-sm font-semibold ${
                          selectedPayment === "executed" ? "w-[15%]" : "w-[20%]"
                        }`}
                      >
                        Transaction ID
                      </th>*/}
                      {selectedPayment === "executed" && (
                        <th
                          className={`text-left text-sm font-semibold ${
                            selectedPayment === "executed"
                              ? "w-[12%]"
                              : "w-[20%]"
                          }`}
                        >
                          Principle
                        </th>
                      )}
                      <th
                        className={`text-left text-sm font-semibold ${
                          selectedPayment === "executed" ? "w-[16%]" : "w-[20%]"
                        }`}
                      >
                        Interest Amount (10%)
                      </th>
                      {selectedPayment === "executed" ? (
                        <th
                          className={`text-left text-sm font-semibold ${
                            selectedPayment === "executed"
                              ? "w-[14%]"
                              : "w-[20%]"
                          }`}
                        >
                          Amount paid
                        </th>
                      ) : (
                        <th
                          className={`text-left text-sm font-semibold ${
                            selectedPayment === "executed"
                              ? "w-[14%]"
                              : "w-[20%]"
                          }`}
                        >
                          Amount payable
                        </th>
                      )}
                      <th
                        className={`text-left text-sm font-semibold ${
                          selectedPayment === "executed" ? "w-[14%]" : "w-[20%]"
                        }`}
                      >
                        Balance pay
                      </th>
                      {selectedPayment === "executed" && (
                        <th
                          className={`text-left text-sm font-semibold ${
                            selectedPayment === "executed"
                              ? "w-[14%]"
                              : "w-[20%]"
                          }`}
                        >
                          Status
                        </th>
                      )}
                    </tr>
                  </thead>
                  {imageLoading && (
                    <div className="w-full h-[calc(100vh-340px)] flex items-center justify-center">
                      <ImageLoading />
                    </div>
                  )}
                  {(!imageLoading &&
                    transactionShow?.transaction_details?.length) ||
                  transactionShow?.prepayment_transaction?.length ? (
                    <tbody
                      className={`overflow-auto max-h-[calc(100vh-310px)] ${
                        transactionShow?.transaction_details?.length === 0 ||
                        transactionShow?.prepayment_transaction?.length === 0
                          ? "h-[calc(100vh-330px)]"
                          : ""
                      }`}
                    >
                      {transactionShow?.transaction_details?.length > 0 &&
                        transactionShow?.transaction_details?.map(
                          (transaction, index) => (
                            <tr
                              key={index}
                              className={`w-full flex items-center py-4 justify-between`}
                            >
                              <td
                                className={`text-left text-xs font-medium ${
                                  selectedPayment === "executed"
                                    ? "w-[15%]"
                                    : "w-[20%]"
                                }`}
                              >
                                {transaction.date || "---"}
                              </td>
                              {/*  <td
                                className={`text-left text-xs font-medium ${
                                  selectedPayment === "executed"
                                    ? "w-[15%]"
                                    : "w-[20%]"
                                }`}
                              >
                                {transaction.transactionId || "---"}
                              </td> */}
                              {selectedPayment === "executed" && (
                                <td
                                  className={`text-left text-xs font-medium ${
                                    selectedPayment === "executed"
                                      ? "w-[12%]"
                                      : "w-[20%]"
                                  }`}
                                >
                                  &#8377;{transaction.principle}
                                </td>
                              )}
                              <td
                                className={`text-left text-xs font-medium ${
                                  selectedPayment === "executed"
                                    ? "w-[16%]"
                                    : "w-[20%]"
                                }`}
                              >
                                &#8377;{transaction.interest_value}
                              </td>
                              <td
                                className={`text-left text-xs font-medium ${
                                  selectedPayment === "executed"
                                    ? "w-[14%]"
                                    : "w-[20%]"
                                }`}
                              >
                                &#8377;{transaction.amount}
                              </td>
                              <td
                                className={`text-left text-xs font-medium ${
                                  selectedPayment === "executed"
                                    ? "w-[14%]"
                                    : "w-[20%]"
                                }`}
                              >
                                &#8377;{transaction.balance_pay}
                              </td>
                              {selectedPayment === "executed" && (
                                <td
                                  className={`text-left text-xs font-medium ${
                                    selectedPayment === "executed"
                                      ? "w-[14%]"
                                      : "w-[20%]"
                                  }`}
                                >
                                  <span
                                    className={`
                                ${
                                  transaction?.status?.toLowerCase() ===
                                  "failed"
                                    ? "red-status"
                                    : transaction?.status?.toLowerCase() ===
                                      "initiated"
                                    ? "blue-status"
                                    : transaction?.status?.toLowerCase() ===
                                      "success"
                                    ? "green-status"
                                    : "blue-status"
                                } px-2 py-1 rounded-full cursor-default capitalize flex items-center justify-center w-fit
                              `}
                                  >
                                    {alterStatus(transaction.status)}
                                  </span>
                                </td>
                              )}
                            </tr>
                          )
                        )}
                      {selectedPayment === "executed" &&
                        transactionShow?.prepayment_transaction?.length > 0 &&
                        transactionShow?.prepayment_transaction?.map(
                          (transaction, index) => (
                            <tr
                              key={index}
                              className={`w-full flex items-center py-4 justify-between`}
                            >
                              <td
                                className={`text-left text-xs font-medium ${
                                  selectedPayment === "executed"
                                    ? "w-[15%]"
                                    : "w-[20%]"
                                }`}
                              >
                                {transaction.date || "---"}
                              </td>
                              <td
                                className={`text-left text-xs font-medium ${
                                  selectedPayment === "executed"
                                    ? "w-[15%]"
                                    : "w-[20%]"
                                }`}
                              >
                                {transaction.transactionId || "---"}
                              </td>
                              <td
                                className={`text-left text-xs font-medium ${
                                  selectedPayment === "executed"
                                    ? "w-[14%]"
                                    : "w-[20%]"
                                }`}
                              >
                                &#8377;{transaction.principle}
                              </td>
                              <td
                                className={`text-left text-xs font-medium ${
                                  selectedPayment === "executed"
                                    ? "w-[14%]"
                                    : "w-[20%]"
                                }`}
                              >
                                &#8377;{transaction.interest_value}
                              </td>
                              <td
                                className={`text-left text-xs font-medium ${
                                  selectedPayment === "executed"
                                    ? "w-[14%]"
                                    : "w-[20%]"
                                }`}
                              >
                                &#8377;{transaction.amount}
                              </td>
                              <td
                                className={`text-left text-xs font-medium ${
                                  selectedPayment === "executed"
                                    ? "w-[14%]"
                                    : "w-[20%]"
                                }`}
                              >
                                &#8377;{transaction.balance_pay}
                              </td>
                              <td
                                className={`text-left text-xs font-medium ${
                                  selectedPayment === "executed"
                                    ? "w-[14%]"
                                    : "w-[20%]"
                                }`}
                              >
                                <span className="bg-[#F0FDF4] text-[#188240] border-[#C4EBD2] border-[0.5px] px-4 rounded cursor-default capitalize">
                                  {alterStatus(transaction.status)}
                                </span>
                              </td>
                            </tr>
                          )
                        )}
                      {transactionShow?.transaction_details?.length > 0 &&
                        transactionShow?.prepayment_details?.length > 0 && (
                          <span
                            style={{
                              fontSize: "18px",
                              fontWeight: "500",
                              width: "100%",
                              height: "100px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            No transactions created
                          </span>
                        )}
                    </tbody>
                  ) : (
                    <NoDataFound insidePage={true} />
                  )}
                </table>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
const MemoizedTransactions = React.memo(Transactions);
export default MemoizedTransactions;
